import { render, staticRenderFns } from "./nav-item-content.mpx?vue&type=template&id=01262254&isComponent&outputPath=components%2Fnav-item-content54eaf879%2Findex"
import script from "./nav-item-content.mpx?vue&type=script&lang=ts&isComponent&outputPath=components%2Fnav-item-content54eaf879%2Findex"
export * from "./nav-item-content.mpx?vue&type=script&lang=ts&isComponent&outputPath=components%2Fnav-item-content54eaf879%2Findex"


/* normalize component */
import normalizer from "!../../../../../example/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports